<template>
  <div>
    <v-container style="max-width: 1200px">
      <v-row style="min-height: 80vh" justify="center" align="center" dense>
        <v-col
          cols="12"
          sm="auto"
          v-for="item in CardList"
          :key="item.id"
          class="d-flex justify-center"
        >
          <v-hover v-slot="{ hover }" class="w-100">
            <v-card
              :elevation="hover ? 15 : 3"
              class="main-menu-card rounded-lg transition-smooth"
            >
              <v-img
                :src="item.src"
                :class="[
                  'main-menu-card__image white--text align-end rounded-lg',
                  item.key === 'terminalStamp'
                    ? 'main-menu-card__image--terminal'
                    : 'main-menu-card__image--redemption',
                ]"
                width="100%"
                height="100%"
                position="center center"
                @click="NavigatePage(item.key)"
              >
                <div class="gradient-overlay"></div>
                <v-card-title
                  :class="[
                    'menu-title',
                    { 'menu-title--th': $i18n.locale === 'th' },
                  ]"
                >
                  {{ $t(item.nameKey) }}
                </v-card-title>
              </v-img>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium">
          Loading, please wait...
        </span>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import enurl from "@/api/environment";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "MainMenu",
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      projectID: localStorage.getItem("ProjectSiteID"),
      menu: {},
      menuConfig: [
        {
          key: "redemption",
          src: require("@/assets/Redemption-customhouse.webp"),
          nameKey: "message.Redemption",
          id: 1,
        },
        {
          key: "terminalStamp",
          src: require("@/assets/TerminalStamp-Customhouse.webp"),
          nameKey: "message.TerminalStamp",
          id: 2,
        },
      ],

    };
  },

  computed: {
    CardList() {
      return this.menuConfig
        .filter((m) => this.menu[m.key] === true)
        .map((m) => ({
          ...m,
          col: 3,
        }));
    },
  },

  created() {
    this.menuConfig.forEach((item) => {
      const image = new Image();
      image.src = item.src;
    });
  },

  async mounted() {
    let self = this;
    self.getDataMenuPermission();
  },

  methods: {
    getDataMenuPermission() {
      let self = this;
      self.LoadingDialog = true;
      axios
        .get(`${this.url}Permission/getDataMenuPermission`)
        .then((response) => {
          if (response.data.status !== 0) return;
          this.menu = response.data.data;
        })
        .catch((error) => {
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          this.LoadingDialog = false;
        });
    },

    NavigatePage(key) {
      switch (key) {
        case "qr":
          this.$router.push("/MyQR");
          break;
        case "redemption":
          this.$router.push("/Main");
          break;
        case "preRegister":
          this.$router.push("/ManagePreRegister");
          break;
        case "terminalStamp":
          this.$router.push("/TerminalStampMain");
          break;
      }
    },


    changeLang(lang) {
      this.$i18n.locale = lang;
    },

  },
};
</script>
<style scoped>
.centered-input-header >>> input {
  text-align: center;
  color: black;
}
.TitleCSS {
  font-size: 18px;
  font-weight: 300;
  color: black;
}
@font-face {
  font-family: "Roboto", sans-serif;
  src: local("English"), url(../assets/Font/Kanit-Regular.ttf);
}
* >>> .v-data-table-header {
  background-color: #333333 !important;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}
.transition-smooth {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.main-menu-card {
  width: 397px;
  height: 470px;
  cursor: pointer;
  border: 1px solid #231f20;
  border-radius: 15px !important;
  box-sizing: border-box;
  overflow: hidden;
}
.main-menu-card__image {
  width: 100%;
  height: 100%;
}
.main-menu-card__image >>> .v-image__image--cover {
  background-size: cover;
  background-position: center center;
}
.main-menu-card__image--redemption >>> .v-image__image--cover {
  transform: scale(1.075);
}
.main-menu-card__image--terminal >>> .v-image__image--cover {
  transform: scale(1.075);
}
.v-card:hover {
  transform: translateY(-8px);
}

.gradient-overlay {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 40%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
  border-radius: 0 0 15px 15px;
}

.menu-title {
  position: absolute;
  bottom: 52px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 35px;
  font-weight: 500;
  text-align: center;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.9);
  font-family: 'Mrs Eaves Lining OT', serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.menu-title--th {
  width: 90%;
  max-width: 90%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "English", sans-serif;
  font-size: 24px;
  line-height: 1.35;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  text-wrap: balance;
}
@font-face {
  font-family: "Mrs Eaves Lining OT";
  src: url("~@/assets/Font/Lining.otf") format("opentype");
  font-style: normal;
  font-weight: normal;
  font-display: swap;
}

@media (max-width: 428px) {
  .main-menu-card {
    width: 100%;
    height: auto;
    aspect-ratio: 397 / 470;
  }
}
</style>
